const STATUS_STYLES = {
  not_started: 'bg-sky-50 text-sky-700 border-sky-100',
  pending: 'bg-amber-50 text-amber-700 border-amber-100',
  processing: 'bg-cyan-50 text-cyan-700 border-cyan-100',
  completed: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  expired: 'bg-slate-100 text-slate-600 border-slate-200',
  failed: 'bg-rose-50 text-rose-700 border-rose-100',
  cancelled: 'bg-slate-100 text-slate-600 border-slate-200',
  canceled: 'bg-slate-100 text-slate-600 border-slate-200',
  refunded: 'bg-violet-50 text-violet-700 border-violet-100',
  manual_review: 'bg-violet-50 text-violet-700 border-violet-100',
  payment_pending: 'bg-amber-50 text-amber-700 border-amber-100',
  order_created: 'bg-amber-50 text-amber-700 border-amber-100',
  payment_received: 'bg-cyan-50 text-cyan-700 border-cyan-100',
  payout_pending: 'bg-cyan-50 text-cyan-700 border-cyan-100',
  kivi_completed: 'bg-emerald-50 text-emerald-700 border-emerald-100',
};

export default function RequestStatusBadge({ status, label }) {
  return (
    <span className={`inline-flex items-center whitespace-nowrap rounded border px-2 py-1 text-[11px] font-medium leading-none ${STATUS_STYLES[status] || 'bg-slate-50 text-slate-600 border-slate-200'}`}>
      {label || status}
    </span>
  );
}
